/**
 * Created by hieult on 1/11/18.
 */
import * as utils from '../functions/utils';
import { REFINE_MODAL } from '../constants/constants';
import PropertyItem, { IPropertyItemType } from './properyItem';
import { IProperyItem } from 'redhotpie-shared-lib/interfaces/IProperyItem';
import { CATEGORY_ID } from '../constants/category';
import Category from './category';

export interface BaseFilter {
  minAge: number;
  maxAge: number;
  location?: {
    LocationType: string;
    [key: string]: any;
  };
  showMeMemberType: Category;
  isVerified: boolean;
  isHasChangeFilter: boolean;
}

interface Filters {
  isCarouselView: boolean;
  isShowPremiumFilters: boolean;
  isShowLocationFilters: boolean;
  minAge: number;
  maxAge: number;
  searchRadius: number;
  onlineNow: boolean;
  withPhotos: boolean;
  hasValidations: boolean;
  isVerified: boolean;
  memberType: string | null;
  seekingMemberType: number;
  location?: {
    LocationType: string;
    [key: string]: any;
  };
}

interface IMemberSearch {
  users: any[];
  filters: Filters;
}

export default class MemberSearch {
  users: any[];
  filters: Filters;

  constructor() {
    this.users = [];
    this.filters = {
      isCarouselView: false,
      isShowPremiumFilters: false,
      isShowLocationFilters: false,
      minAge: 18,
      maxAge: 80,
      searchRadius: REFINE_MODAL.PROXIMITY_DEFAULT_SHOW,
      onlineNow: false,
      withPhotos: false,
      hasValidations: false,
      isVerified: false,
      memberType: null,
      seekingMemberType: 25,
    };
  }

  static mappingObject(propertyItem: IPropertyItemType, activeId: number): IProperyItem {
    const _propertyItem = new PropertyItem();
    _propertyItem.id = propertyItem.ItemID;
    _propertyItem.listId = propertyItem.ListID;
    _propertyItem.label = propertyItem.ItemName || '';
    _propertyItem.icSrc = propertyItem.icSrc || '';
    _propertyItem.value = propertyItem.value || '';
    _propertyItem.active = propertyItem.ItemID === activeId;
    return _propertyItem;
  }

  static mappingObjects(propertyItems: IPropertyItemType[], activeId: number): IProperyItem[] {
    const _propertyItems: IProperyItem[] = [];
    propertyItems.forEach(property => {
      const _property = PropertyItem.mappingObject(property, activeId);
      _propertyItems.push(_property);
    });
    return _propertyItems;
  }

  static getIconObjects(categoryId: string, propertyItems: IProperyItem[]): IProperyItem[] {
    const _propertyItems: IProperyItem[] = [];
    propertyItems.forEach(property => {
      const _property = property;
      _property.icSrc = utils.getIconCategoryItem(categoryId, property.id);
      _propertyItems.push(_property);
    });
    return _propertyItems;
  }

  static convertLabelObjects(categoryId: string, propertyItems: IProperyItem[]): IProperyItem[] {
    const _propertyItems: IProperyItem[] = [];
    propertyItems.forEach(property => {
      const _property = property;
      _property.label = utils.convertLabelCategory(_property.id);
      _propertyItems.push(_property);
    });
    return _propertyItems;
  }

  static mappingUserSearchSettings(propertyItem: any): MemberSearch {
    const _propertyItem = new MemberSearch();
    _propertyItem.filters = {
      minAge: propertyItem.AgeMin,
      maxAge: propertyItem.AgeMax,
      location: {
        ...propertyItem.Location,
        LocationType: propertyItem.Location ? propertyItem.Location.Type : '',
      },
      searchRadius: propertyItem.SearchRadius,
      memberType: propertyItem.MemberType,
      seekingMemberType: propertyItem.SeekingMemberType,
      isCarouselView: false,
      isShowPremiumFilters: false,
      isShowLocationFilters: false,
      onlineNow: false,
      withPhotos: false,
      hasValidations: false,
      isVerified: false,
    };
    return _propertyItem;
  }
}
